// extracted by mini-css-extract-plugin
module.exports = {"trigger":"Tooltip_trigger__f-swK","tooltip":"Tooltip_tooltip__3WxXW","visible":"Tooltip_visible__-X4Dn","delay":"Tooltip_delay__3n3_E","text":"Tooltip_text__tc9S6"};